export const RECEIPT_CONFIGURE_SLICE_NAME = "receiptConfigure"
